const STORAGE_KEY = "dr-hoffmann-leonardo-booking-draft";

const readRaw = () => {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const loadLeonardoBookingDraft = () => {
  const data = readRaw();
  if (!data || typeof data !== "object") return null;
  return data;
};

export const saveLeonardoBookingDraft = (draft) => {
  if (typeof sessionStorage === "undefined" || !draft) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch {
    /* quota / private mode */
  }
};

export const clearLeonardoBookingDraft = () => {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
